import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { CompareService } from '../core/compare.service';
import { ToastService } from '../core/toast.service';

@Component({
  selector: 'app-compare-bar',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './compare-bar.component.html',
  styleUrl: './compare-bar.component.css',
})
export class CompareBarComponent {
  protected readonly compare = inject(CompareService);
  private readonly toast = inject(ToastService);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);

  protected remove(id: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.compare.remove(id);
  }

  protected clear(): void {
    this.compare.clear();
  }

  protected goCompare(): void {
    if (this.compare.count() < 2) {
      this.toast.show(this.translate.instant('compare.needAtLeastTwo'));
      return;
    }
    void this.router.navigate(['/compare']);
  }
}
